module.exports = __webpack_public_path__ + "static/media/ci-con-chip.77cffd0c.jpg";